import Draggable from "react-draggable";
import Paper from "@mui/material/Paper";
import React from "react";

export function PaperComponentDraggable(props) {
  const nodeRef = React.useRef(null);
  
  return (
    <Draggable
      nodeRef={nodeRef}  
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper ref={nodeRef} {...props} />
    </Draggable>
  );
}
